<template>
  <div class="page-help-admin">
    <div class="page-title">
      <div>
        <h2>后台帮助管理</h2>
        <p>维护桥宝在各个后台页面展示的说明内容。</p>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="openForm()">新增页面帮助</el-button>
    </div>
    <div class="filters">
      <el-input
        v-model="query.keyword"
        clearable
        placeholder="页面名称、路由或关键词"
        @keyup.enter.native="load"
      /><el-select v-model="query.status" clearable placeholder="全部状态"
        ><el-option label="草稿" :value="0"/><el-option label="已发布" :value="1"/><el-option
          label="已停用"
          :value="2"/></el-select
      ><el-button type="primary" @click="load">查询</el-button>
    </div>
    <el-table :data="rows" border v-loading="loading">
      <el-table-column prop="pageName" label="页面名称" min-width="150" />
      <el-table-column prop="routePath" label="页面路由" min-width="220" />
      <el-table-column prop="title" label="帮助标题" min-width="220" show-overflow-tooltip />
      <el-table-column label="状态" width="100"
        ><template slot-scope="s"
          ><el-tag
            :type="s.row.status === 1 ? 'success' : s.row.status === 2 ? 'info' : 'warning'"
            >{{ statusText(s.row.status) }}</el-tag
          ></template
        ></el-table-column
      >
      <el-table-column prop="versionNo" label="版本" width="80" />
      <el-table-column label="更新时间" width="180"
        ><template slot-scope="s">{{ formatTime(s.row.mddate) }}</template></el-table-column
      >
      <el-table-column label="操作" width="150" fixed="right"
        ><template slot-scope="s"
          ><el-button type="text" @click="openForm(s.row)">编辑</el-button
          ><el-button type="text" class="danger" @click="remove(s.row)">删除</el-button></template
        ></el-table-column
      >
    </el-table>
    <el-pagination
      class="pager"
      :current-page.sync="query.page"
      :page-size.sync="query.pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next"
      @current-change="load"
      @size-change="load"
    />

    <el-dialog
      :title="form.id ? '编辑页面帮助' : '新增页面帮助'"
      :visible.sync="dialog"
      width="760px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="96px">
        <el-row :gutter="18"
          ><el-col :span="12"
            ><el-form-item label="页面名称" prop="pageName"
              ><el-input v-model="form.pageName"/></el-form-item></el-col
          ><el-col :span="12"
            ><el-form-item label="页面路由" prop="routePath"
              ><el-input
                v-model="form.routePath"
                placeholder="例如 /goods/list"/></el-form-item></el-col
        ></el-row>
        <el-form-item label="帮助标题" prop="title"
          ><el-input v-model="form.title" maxlength="160" show-word-limit
        /></el-form-item>
        <el-form-item label="页面简介"
          ><el-input
            v-model="form.summary"
            type="textarea"
            :rows="3"
            maxlength="1000"
            show-word-limit
        /></el-form-item>
        <el-form-item label="操作步骤"
          ><el-input v-model="stepText" type="textarea" :rows="5" placeholder="每行一个步骤"
        /></el-form-item>
        <el-form-item label="注意事项"
          ><el-input v-model="noticeText" type="textarea" :rows="4" placeholder="每行一条注意事项"
        /></el-form-item>
        <el-form-item label="常见问题"
          ><el-input
            v-model="faqText"
            type="textarea"
            :rows="5"
            placeholder="每行一组，格式：问题|答案"
        /></el-form-item>
        <el-form-item label="搜索关键词"
          ><el-input v-model="form.keywords" placeholder="多个关键词用英文逗号分隔"
        /></el-form-item>
        <el-row :gutter="18"
          ><el-col :span="12"
            ><el-form-item label="自动提示"
              ><el-select v-model="form.autoPrompt" style="width:100%"
                ><el-option label="不自动提示" :value="0"/><el-option
                  label="首次进入提示"
                  :value="1"/><el-option
                  label="每次进入提示"
                  :value="2"/></el-select></el-form-item></el-col
          ><el-col :span="12"
            ><el-form-item label="内容状态"
              ><el-select v-model="form.status" style="width:100%"
                ><el-option label="草稿" :value="0"/><el-option
                  label="已发布"
                  :value="1"/><el-option
                  label="已停用"
                  :value="2"/></el-select></el-form-item></el-col
        ></el-row>
      </el-form>
      <span slot="footer"
        ><el-button @click="dialog = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="save">保存帮助</el-button></span
      >
    </el-dialog>
  </div>
</template>
<script>
import { getPageHelpList, savePageHelp, deletePageHelp } from "@/api/pageHelp";
export default {
  name: "PageHelpAdmin",
  data() {
    return {
      loading: false,
      saving: false,
      rows: [],
      total: 0,
      query: { keyword: "", status: null, page: 1, pageSize: 15 },
      dialog: false,
      form: {},
      stepText: "",
      noticeText: "",
      faqText: "",
      rules: {
        pageName: [{ required: true, message: "请输入页面名称", trigger: "blur" }],
        routePath: [{ required: true, message: "请输入页面路由", trigger: "blur" }],
        title: [{ required: true, message: "请输入帮助标题", trigger: "blur" }]
      }
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const r = await getPageHelpList(this.query);
        this.rows = (r.data && r.data.entitys) || [];
        this.total = (r.data && r.data.totalCount) || 0;
      } finally {
        this.loading = false;
      }
    },
    statusText(v) {
      return v === 1 ? "已发布" : v === 2 ? "已停用" : "草稿";
    },
    formatTime(v) {
      return v ? new Date(v).toLocaleString("zh-CN", { hour12: false }) : "-";
    },
    parse(v, d = []) {
      try {
        return v ? JSON.parse(v) : d;
      } catch (e) {
        return d;
      }
    },
    openForm(row) {
      this.form = row
        ? { ...row }
        : {
            id: null,
            pageName: "",
            routePath: "",
            title: "",
            summary: "",
            keywords: "",
            autoPrompt: 1,
            status: 0
          };
      this.stepText = this.parse(this.form.stepsJson).join("\n");
      this.noticeText = this.parse(this.form.noticesJson).join("\n");
      this.faqText = this.parse(this.form.faqsJson)
        .map(x => `${x.question}|${x.answer}`)
        .join("\n");
      this.dialog = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    lines(v) {
      return (v || "")
        .split("\n")
        .map(x => x.trim())
        .filter(Boolean);
    },
    save() {
      this.$refs.form.validate(async ok => {
        if (!ok) return;
        this.saving = true;
        try {
          const faqs = this.lines(this.faqText).map(line => {
            const i = line.indexOf("|");
            return {
              question: i >= 0 ? line.slice(0, i).trim() : line,
              answer: i >= 0 ? line.slice(i + 1).trim() : ""
            };
          });
          const r = await savePageHelp({
            ...this.form,
            stepsJson: JSON.stringify(this.lines(this.stepText)),
            noticesJson: JSON.stringify(this.lines(this.noticeText)),
            faqsJson: JSON.stringify(faqs)
          });
          if (r.bizcode === 100) {
            this.$message.success("帮助内容已保存");
            this.dialog = false;
            this.load();
          }
        } finally {
          this.saving = false;
        }
      });
    },
    remove(row) {
      this.$confirm("删除后无法恢复，确认删除这条页面帮助？", "删除帮助", { type: "warning" })
        .then(async () => {
          const r = await deletePageHelp({ id: row.id });
          if (r.bizcode === 100) {
            this.$message.success("已删除");
            this.load();
          }
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped lang="scss">
.page-help-admin {
  padding: 24px;
  background: #fff;
  min-height: calc(100vh - 120px);
}
.page-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.page-title h2 {
  margin: 0 0 8px;
  font-size: 22px;
}
.page-title p {
  margin: 0;
  color: #606266;
}
.filters {
  display: flex;
  gap: 12px;
  padding: 20px 0;
}
.filters .el-input {
  width: 280px;
}
.filters .el-select {
  width: 160px;
}
.pager {
  text-align: right;
  margin-top: 20px;
}
.danger {
  color: #f56c6c;
}
</style>
